import { render } from "./DocumentClassTableColumnsSubView.vue?vue&type=template&id=0b2e9aa0&ts=true"
import script from "./DocumentClassTableColumnsSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTableColumnsSubView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__